import UpdateDigitalAssetRequestModelBase from '../_generated/modelBases/update-digital-asset-request-model-base';

export default class UpdateDigitalAssetRequestModel extends UpdateDigitalAssetRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
